import clientDeepLinks from "./clientDeepLinks";
import handleDeepLink from "./handleDeepLink";
import rfStore from "./rfStore";

export default function directToClientLogin(inviteCode = "") {
  const rfState = rfStore.getRFState();
  rfState &&
    rfStore.setRFState({
      ...rfState,
      token: "",
    });
  handleDeepLink(clientDeepLinks.loginPage(inviteCode));
}
